'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/network-operations-center.png'
import ServiceDetailsImg1 from '../../assets/images/services/deisgn-implementation-1.jpg'
import ServiceDetailsImg2 from '../../assets/images/services/deisgn-implementation-2.jpg'

const SkylineMain = () => {
    // State to hold dynamic content
    const [serviceDetails] = useState({
        title: "Network Operations Center",
        image1: ServiceDetailsImg,
        title2: "Network Operations Center",
        points: [
            "Application software installations, troubleshooting, and updating",
            "Email management services",
            "Backup and storage management",
            "Network discovery and assessments",
            "Policy enforcement",
            "Firewall and intrusion prevention system (IPS) monitoring and management on NOC computers",
            "Antivirus scanning and remediation",
            "Patch management and whitelisting",
            "Shared threat analysis",
            "Optimization and quality of service reporting",
            "Voice and video traffic management",
            "Performance reporting and improvement recommendations",
        ],
        images: [ ServiceDetailsImg1, ServiceDetailsImg2
        ],
        features: [
            {
                icon: "icon-crane-1",
                title: "Reliable Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
            {
                icon: "icon-buildings",
                title: "Building Roof Repair",
                text: "Roof service involves the installation, maintenance, and repair of roofs for the commercial",
                link: "#",
            },
        ],
    });

    return (
        <React.Fragment>
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">
                                    <h2 className="service-details__title-one">{serviceDetails.title}</h2>
                                    <div className="service-details__img-one">
                                        <img src={serviceDetails.image1} alt="" />
                                    </div>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <ul className="list-unstyled service-details__points">
    {serviceDetails.points.map((point, index) => (
        <li key={index}>
            <div className="icon">
                <i className="far fa-check" />
            </div>
            <div className="text">
                <p>{point}</p>
            </div>
        </li>
    ))}
</ul>   
                                </div>
                                <div className="service-details__images-box">
                                    <div className="row">
                                        {serviceDetails.images.map((image, index) => (
                                            <div key={index} className="col-xl-6 col-lg-6">
                                                <div className="service-details__images-single">
                                                    <img src={image} alt="" />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="service-details__content-three">
                                    <h4 className="service-details__title-four">{serviceDetails.content3Title}</h4>
                                    <p className="service-details__text-3">{serviceDetails.text4}</p>
                                    <p className="service-details__text-4">{serviceDetails.text5}</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details__sidebar">
                                <div className="service-details__service-list-box">
                                <h4 className="service-details__sidebar-title">Main Service</h4>
                                <ul className="service-details__service-list list-unstyled">
                                    <li>
                                    <Link to="/security-consulting">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Security Consulting
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/audit-&-compliance">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Audit & Compliance
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/cloud-security">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Cloud Security
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/network-security">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Network Security
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/design-&-implementation">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Design & Implementation
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/managed-it-services">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Managed IT Services
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/ot-iot-security">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           OT, iOT Security
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/api-security">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           API Security
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/offensive-security-red-teaming">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Offensive Security, Red Teaming
                                                                       </Link>
                                                                       </li>
                                                                       <li>
                                                                       <Link to="/vulnerability-assessment">
                                                                           {" "}
                                                                           <span className="icon-dubble-arrow-right" />
                                                                           Vulnerability Assessment
                                                                       </Link>
                                    </li>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default SkylineMain;
